import React from 'react';
import { IoClose } from 'react-icons/io5';
import {
  ModalOverlay,
  ModalContent,
  ModalTitle,
  CloseButton,
  QRGrid,
  QRBlock,
  QRLabel,
  QRDesc
} from './QRCodeModal.styles';
import { APP_STORE_URL, PLAY_STORE_URL } from '../../constants';
import { generateQRCodeSVG } from '../../utils';

interface QRCodeModalProps {
  open: boolean;
  onClose: () => void;
}

const QRCodeModal: React.FC<QRCodeModalProps> = ({ open, onClose }) => {
  if (!open) return null;
  return (
    <ModalOverlay>
      <ModalContent>
        <ModalTitle>Download iDen2 App</ModalTitle>
        <CloseButton onClick={onClose} aria-label="Close">
          <IoClose />
        </CloseButton>
        <QRGrid>
          <QRBlock>
            <div dangerouslySetInnerHTML={{ __html: generateQRCodeSVG(APP_STORE_URL, 104) }} />
            <QRLabel>App Store</QRLabel>
          </QRBlock>
          <QRBlock>
            <div dangerouslySetInnerHTML={{ __html: generateQRCodeSVG(PLAY_STORE_URL, 104) }} />
            <QRLabel>Google Play Store</QRLabel>
          </QRBlock>
        </QRGrid>
        <QRDesc>
          Scan the appropriate QR code with your device's camera to<br />
          download the iDen2 app
        </QRDesc>
      </ModalContent>
    </ModalOverlay>
  );
};

export default QRCodeModal;
